import { injectable, inject } from 'inversify'
import Debug from 'debug';
import { CommandQueue } from '@/app/shared/command-queue';
import { ResettableCancelToken, compoundCancelToken, CancelToken } from '@/app/shared/utils/cancel-token'
import * as Commands from './commands'

const debug = Debug('quiz-service');

export const QuizServiceSymbol = Symbol.for('QuizService')

@injectable()
export class QuizBankService2 {

  private localQueue: CommandQueue;
  private cancelToken: ResettableCancelToken

  constructor(
    @inject(Commands.LoadQuizzesCommandHandler)
    private loadQuizzesCommand: Commands.LoadQuizzesCommandHandler) {
    this.localQueue = new CommandQueue('quiz-service-local');
    this.cancelToken = new ResettableCancelToken()
  }

  public start(source: Commands.QuizSource, finalQuizId: string) {
    debug('starting QuizService', source);

    this.localQueue.start();

    if (source) {
      const token = this.cancelToken.cancelAndReset()

      this.localQueue.queue('load-quizzes',
                            (queueCancel) => this.load(source, finalQuizId, token, queueCancel));
    }
  }

  public reset(source: Commands.QuizSource, finalQuizId: string) {
    debug('resetting QuizService', source);

    if (source) {
      const token = this.cancelToken.cancelAndReset()

      this.localQueue.queue('reload-quizzes',
                            (queueCancel) => this.load(source, finalQuizId, token, queueCancel));
    }
  }

  private async load(source: Commands.QuizSource, finalQuizId: string, token: CancelToken,
                     queueCancel: CancelToken) {
    await this.loadQuizzesCommand.execute(source, finalQuizId, compoundCancelToken(token, queueCancel))
  }

  public async finish() {

    this.cancelToken.cancelAndReset()
    const stopPromises = [
      this.localQueue.stop(),
    ];

    await Promise.all(stopPromises);
  }
}
